import React from "react";
import PropTypes from "prop-types";
import styles from "./QualifyHeader.module.css";
import QualifyHeaderImage from "./Images/QualifyHeader.png";
import { useTranslation } from "react-i18next";

export function QualifyHeader({ onClick }) {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.textContent}>
        <div className={styles.title}>{t("Eagle Qualifications")}</div>
        <div className={styles.subtitle}>
          {t("How to qualify as an Eagle or Double")}
        </div>
      </div>
      <div className={styles.imageContent} onClick={onClick}>
        <img src={QualifyHeaderImage} />
      </div>
    </div>
  );
}

QualifyHeader.propTypes = {
  onClick: PropTypes.func.isRequired,
};
